import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faUserGroup, faUsers } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";

const GroupCard = ({ group }) => {
  return (
    <div className="card w-full rounded-xl bg-white shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl">
      <div className="p-5 flex min-h-full flex-col">
        <div className="flex items-start gap-3">
          <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-[#eaf3fa] text-[#004a7e]">
            <FontAwesomeIcon icon={faUserGroup} size="lg" />
          </div>
          <div className="flex-1">
            <p className="text-xs font-bold uppercase tracking-wide text-[#004a7e]">
              Event group
            </p>
            <h2 className="mt-1 text-xl font-black leading-tight text-gray-900">
              {group?.groupName}
            </h2>
          </div>
        </div>
        <div className="mt-4 rounded-lg bg-gray-50 p-3">
          <p className="flex items-center gap-2 text-sm font-semibold text-gray-700">
            <FontAwesomeIcon icon={faUsers} className="text-[#004a7e]" />
            {group?.noOfParticipants || 0}{" "}
            {(group?.noOfParticipants || 0) === 1
              ? "participant"
              : "participants"}
          </p>
        </div>

        <div className="mt-5">
          <Link
            to={`/group/${group.id}`}
            className="inline-flex w-full items-center justify-center rounded-lg bg-[#004a7e] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#003a64]"
          >
            <FontAwesomeIcon icon={faEye} className="mr-2" /> Manage
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GroupCard;
